import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { DEFERRED_MESSAGE } from "@/lib/offlineTransport";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { consumeMagicLink } = useAuth();
  const started = useRef(false);
  const [status, setStatus] = useState("checking");
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  useEffect(() => {
    if (started.current) return undefined;
    started.current = true;
    let active = true;
    if (!email || !token) {
      setStatus("missing");
      return () => { active = false; };
    }
    setStatus("checking");
    consumeMagicLink({ email, token })
      .then(() => {
        if (!active) return;
        toast.success("Welkom terug");
        setStatus("done");
        navigate("/", { replace: true });
      })
      .catch((error) => { if (active) setStatus(error?.response?.data?.detail === DEFERRED_MESSAGE ? "offline" : "failed"); });
    return () => { active = false; };
  }, [consumeMagicLink, email, navigate, token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-600 text-3xl text-white" aria-hidden="true">🐝</div>
        <div className="font-display text-2xl font-bold text-zinc-900">Open Bijen App</div>
        {status === "checking" && <div className="mt-2 text-sm text-zinc-500">We zetten je sessie klaar...</div>}
        {status === "missing" && <div className="mt-2 text-sm text-zinc-500">Deze link mist gegevens.</div>}
        {status === "failed" && <div className="mt-2 text-sm text-red-600">Deze link is ongeldig of verlopen.</div>}
        {status === "offline" && <div className="mt-2 text-sm text-amber-700">{DEFERRED_MESSAGE}</div>}

        {status !== "checking" && status !== "done" && (
          <Button asChild className="mt-5 w-full h-11 bg-amber-600 hover:bg-amber-700">
            <Link to="/login">Nieuwe link aanvragen</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
